<template>
  <SkeletonTheme color="#e3e3e3" highlight="#c3c3c3">
    <Skeleton
      height="50px"
      width="250px"
      class="d-inline-block
      mr-3"
    />
    <Skeleton height="50px" width="250px" />

    <b-row class="mt-4">
      <b-col
        xs="12"
        sm="6"
        md="6"
        lg="4"
        xl="3"
        v-for="(item, index) in [1, 2, 3, 4]"
        :key="index"
      >
        <Skeleton height="160px" width="100%" />
      </b-col>
    </b-row>
  </SkeletonTheme>
</template>

<script>
import { Skeleton, SkeletonTheme } from "vue-loading-skeleton";

export default {
  name: "SkeletonLoadingCard",
  components: {
    Skeleton,
    SkeletonTheme
  }
};
</script>

<style></style>
